import { useIntl } from '@capsicum/common';
import { Label, TextButton } from '@capsicum/common-web';
import { VaultClosedIcon } from '@capsicum/common-web/icons';

type StakeFanTokenChipProps = {
	currencyShortName: string;
	onClickAction: () => void;
	testId: string;
};

export const StakeFanTokenChip = ({ currencyShortName, onClickAction, testId }: StakeFanTokenChipProps) => {
	const { $t } = useIntl();

	const intlStakeTokenAmountNeeded = $t('survey.details.stakeTokenAmountNeeded', { currencyShortName });
	const intlStakeTokenLink = $t('survey.details.tokenStakeLink', { currencyShortName });

	return (
		<Label icon={VaultClosedIcon} label={intlStakeTokenAmountNeeded} variant="outlined">
			<TextButton
				color="brand"
				testID={testId}
				text={intlStakeTokenLink}
				textSize="small"
				onClick={onClickAction}
			/>
		</Label>
	);
};
